<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <mat-card style="background: #f7f7f7;">
        <mat-tab-group #tabGroup mat-stretch-tabs (selectedTabChange)="onTabChange($event.index)">

            <mat-tab label="Charitable Contributions">
                <div style="padding: 15px;" *ngIf="tabGroup.selectedIndex === 0">
                    <button mat-raised-button color="primary" (click)="editComapnyListCC()">Edit Company List</button>
                </div>
                <accDist-table-component *ngIf="tabGroup.selectedIndex === 0" [data]='companyCCDetails' [isLoading]='isLoadingCompanyDetails'>
                </accDist-table-component>
            </mat-tab>

            <mat-tab label="Community Investment/ Community Grants">
                <div style="padding: 15px;" *ngIf="tabGroup.selectedIndex === 1">
                    <button mat-raised-button color="primary" (click)="editComapnyListCI()">Edit Company List</button>
                </div>
                <!-- <div class="userHeading">
                        Selected Company List
                </div> -->
                <accDist-table-component *ngIf="tabGroup.selectedIndex === 1" [data]='companyCIDetails' [isLoading]='isLoadingCompanyDetails'>
                </accDist-table-component>
            </mat-tab>

            <mat-tab label="Plant for the Planet">
                <div style="padding: 15px;" *ngIf="tabGroup.selectedIndex === 2">
                    <button mat-raised-button color="primary" (click)="editComapnyListPFTP()">Edit Company List</button>
                </div>
                <accDist-table-component *ngIf="tabGroup.selectedIndex === 2" [data]='companyPPDetails' [isLoading]='isLoadingCompanyDetails'>
                </accDist-table-component>
            </mat-tab>

        </mat-tab-group>
    </mat-card>
</div>